<template>
  <v-layout row wrap>
    <v-dialog
      ref="pickerDialog"
      v-model="pickerDialog"
      lazy
      full-width
      max-width="580px"
    >
      <v-card>
        <v-card-title
          class="title primary white--text hidden-xs-only"
        >
          <v-layout row>
            <v-flex xs6>
              Start Date
            </v-flex>
            <v-flex xs6 class="pl-3">
              End Date
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex xs12 sm6 class="text-xs-center">
              <h3 class="title primary white--text pa-2 hidden-sm-and-up"> Start Date</h3>
              <v-date-picker
                class="elevation-0"
                color="grey lighten-1"
                v-model="form.startDate"
                show-current="false"
                no-title
                :min="startMin"
                :max="startMax"
              ></v-date-picker>
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-center">
              <h3 class="title primary white--text pa-2 hidden-sm-and-up"> End Date</h3>
              <v-date-picker
                class="elevation-0"
                color="grey lighten-1"
                v-model="form.endDate"
                show-current="false"
                :allowed-dates="allowDatesEnd"
                no-title
                :min="endMin"
                :max="endMax"
              ></v-date-picker>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-switch class="mt-0 ml-2" color="secondary" hide-details v-model="form.weekly" label="Weekly"></v-switch>
          <span v-show="alert.active" class="caption warning--text pl-2">{{alert.msg}}</span>
          <v-spacer></v-spacer>
          <v-btn
            flat
             @click="[form.startDate = null, form.endDate = null]"
          >
            clear
          </v-btn>
          <v-btn
            color="primary"
            @click="applyDateRange"
            :loading="loading"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex v-if="$route.name !== 'Report Show'" xs12>
      <!-- Start toolbar -->
      <v-toolbar flat dense color="white" class="mt-3">
        <v-toolbar-title>Statistics</v-toolbar-title>
        <label aria-hidden="true" class="v-label ml-3 mr-1 pt-1 theme--light hidden-sm-and-down">Daily</label>
        <div class="hidden-sm-and-down">
          <v-switch color="secondary" readonly hide-details v-model="weeklyStats" label="Weekly"></v-switch>
        </div>
        <v-spacer></v-spacer>
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon>
            <v-icon @click="toggleWeekleft">keyboard_arrow_left</v-icon>
          </v-btn>
          <v-btn @click="pickerDialog = true" flat>{{  queryDateStart | calendarShorter }} - {{ queryDateEnd | calendarShorter }} <v-icon>keyboard_arrow_down</v-icon></v-btn>
          <v-btn :disabled="disableToggle" icon>
            <v-icon @click="toggleWeekRight">keyboard_arrow_right</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- End toolbar -->
    </v-flex>

    <v-flex xs12 sm4 class="pt-3">
      <v-card
        flat
        class="mt-3 mx-auto"
      >
        <v-sheet
          v-if="activeCalories"
          class="v-sheet--offset mx-auto"
          color="secondary"
          elevation="2"
          max-width="calc(100% - 32px)"
        >
          <v-sparkline
            :labels="activeLabels"
            :value="activeCaloriesOnly"
            color="white"
            line-width="2"
            padding="16"
          ></v-sparkline>
        </v-sheet>

        <v-card-text class="pt-0 ">
          <div class="title font-weight-light mb-2">
            <span v-if="(report && report.weekly_stats) || weeklyStats">Weekly:</span>
            <span v-else>Daily:</span> Calories (protein)
          </div>
          <table style="width: 100%">
            <tbody>
              <tr class="mb-2" v-for="(item, index) in activeCalories"
              :key="'calories: ' + index">
                <td style="width: 40px" class="text-xs-left"><span class="caption">{{activeLabels[index]}}</span></td>
                <td class="text-xs-left"><span class="body-2">{{item[0]}} </span><span v-if="item[1] > 0">({{item[1]}}g)</span></td>
                <td class="text-xs-right">
                  <span class="caption">
                  kcals
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <v-divider class="my-2"></v-divider>
          <span class="caption grey--text font-weight-light">
            Avg. <strong>{{activeCaloriesTotals.average | round}}</strong> calories per day.
            &nbsp
            <strong>{{activeCaloriesTotals.total}}</strong> total calories.
          </span>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm4 class="pt-3">
      <v-card
        flat
        class="mt-3 mx-auto"
      >
        <v-sheet
          v-if="activeWeight"
          class="v-sheet--offset mx-auto"
          color="secondary"
          elevation="2"
          max-width="calc(100% - 32px)"
        >
          <v-sparkline
            :labels="activeLabels"
            :value="activeWeight"
            color="white"
            line-width="2"
            padding="16"
          ></v-sparkline>
        </v-sheet>

        <v-card-text class="pt-0 ">
          <div class="title font-weight-light mb-2">
            <span v-if="(report && report.weekly_stats) || weeklyStats">Weekly:</span>
            <span v-else>Daily:</span> Weight
          </div>
          <table style="width: 100%">
            <tbody>
              <tr class="mb-2" v-for="(item, index) in activeWeight"
              :key="'weight: ' + index">
                <td style="width: 40px" class="text-xs-left"><span class="caption">{{activeLabels[index]}}</span></td>
                <td class="text-xs-left"><span class="body-2">{{item | displayWeight}}</span></td>
                <td class="text-xs-right">
                  <span class="caption">
                  {{units.weight}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <v-divider class="my-2"></v-divider>
          <span v-if="activeWeightTotals" class="caption grey--text font-weight-light">
            <v-icon size="12" :color="activeWeightTotals.color">{{activeWeightTotals.icon}}</v-icon><strong :class="activeWeightTotals.color + '--text'">{{activeWeightTotals.value | displayWeight | weight}}</strong> {{weightMessage}}
          </span>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm4 class="pt-3">
      <v-card
        flat
        class="mt-3 mx-auto"
      >
        <v-sheet
          v-if="activeSteps"
          class="v-sheet--offset mx-auto"
          color="secondary"
          elevation="2"
          max-width="calc(100% - 32px)"
        >
          <v-sparkline
            :labels="activeLabels"
            :value="activeSteps"
            color="white"
            line-width="2"
            padding="16"
          ></v-sparkline>
        </v-sheet>
        <v-card-text class="pt-0 ">
          <div class="title font-weight-light mb-2">
            <span v-if="(report && report.weekly_stats) || weeklyStats">Weekly:</span>
            <span v-else>Daily:</span> Steps
          </div>
          <table style="width: 100%">
            <tbody>
              <tr class="mb-2" v-for="(item, index) in activeSteps"
              :key="'steps: ' + index">
                <td style="width: 40px" class="text-xs-left"><span class="caption">{{activeLabels[index]}}</span></td>
                <td class="text-xs-left"><span class="body-2">{{item}}</span></td>
                <td class="text-xs-right">
                  <span class="caption">
                  steps
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <v-divider class="my-2"></v-divider>
          <span class="caption grey--text font-weight-light">
            Avg. <strong>{{activeStepsTotals.average | round}}</strong> steps per day.
            &nbsp
            <strong>{{activeStepsTotals.total}}</strong> total steps.
          </span>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex v-if="measurements.length > 0" xs12>
      <v-data-table
        select-all
        :headers="headers"
        :items="measurements"
        :rows-per-page-items="rows"
        v-model="selectedMeasurements"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              v-model="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td class="text-xs-center">{{ props.item.milestone }}</td>
          <td class="text-xs-left">{{ props.item.chest }}</td>
          <td class="text-xs-left">{{ props.item.waist }}</td>
          <td class="text-xs-left">{{ props.item.leftArm }}</td>
          <td class="text-xs-left">{{ props.item.leftArm }}</td>
          <td class="text-xs-left">{{ props.item.leftLeg }}</td>
          <td class="text-xs-left">{{ props.item.leftLeg }}</td>
          <td class="text-xs-left">{{ props.item.created_at | calendarNoTime }}</td>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex v-if="$route.name !== 'Report Show'" xs12 md6>
      <div style="width: 100%; text-align: center;">
        <stats-share-dialog @reported="addReport" :user="user" :startDate="queryDateStart" :endDate="queryDateEnd" :selectedMeasurements="selectedMeasurements" :stats="activeStats" :weeklyStats="weeklyStats"></stats-share-dialog>
      </div>
    </v-flex>
    <v-flex v-if="$route.name !== 'Report Show'" xs12 md6 mb-3>
      <v-expansion-panel popout>
        <v-expansion-panel-content
          v-for="(item, index) in reports"
          :key="index"
        >
          <template v-slot:header>
            <div>Stats for {{item.start_date | calendarShortUnix}} - {{item.end_date | calendarShortUnix}}</div>
          </template>
          <v-card class="elevation-0">
            <div class="pa-2">
              <v-textarea
                name="message"
                v-model="item.message"
                label="Message"
                @blur="updateReport(item)"
              ></v-textarea>
            </div>
            <v-card-actions>
              <p>
                <span class="caption">Read at: {{ item.read_at | calendar }}</span>
              </p>
              <v-spacer></v-spacer>
              <v-btn
                @click="deleteReport(item)"
              >
                delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
    <v-snackbar
      v-model="snack.active"
      bottom
      :timeout="snack.timeout"
    >
      {{snack.text}}
      <v-btn
        color="secondary"
        flat
        @click="snack.active = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { db } from '@/services/firebase'
import { manageDates } from '@/mixins/manageDates'
import statsShareDialog from '@/components/partial/stats-share-dialog.vue'
export default {
  name: 'statistics',
  components: {
    statsShareDialog
  },
  mixins: [
    manageDates
  ],
  data: function () {
    return {
      fetched: false,
      alert: {
        active: false,
        msg: 'Please check dates.'
      },
      snack: {
        active: false,
        timeout: 3000,
        text: 'Report Updated!',
        color: 'secondary'
      },
      loading: false,
      loadingDelete: false,
      reports: [],
      dailyStats: [],
      measurements: [],
      selectedMeasurements: [],
      weeklyStats: false,
      pickerDialog: false,
      form: {
        weekly: false,
        endDate: null,
        startDate: null
      },
      units: JSON.parse(localStorage.getItem('measureSystem')),
      headers: [
        { text: 'Milestone', value: 'title', sortable: false, align: 'left' },
        { text: 'Chest', value: 'chest', sortable: false, align: 'left' },
        { text: 'Waist', value: 'waist', sortable: false, align: 'left' },
        { text: 'left Arm', value: 'leftArm', sortable: false, align: 'left' },
        { text: 'Right Arm', value: 'rightArm', sortable: false, align: 'left' },
        { text: 'Left Leg', value: 'leftLeg', sortable: false, align: 'left' },
        { text: 'Right Leg', value: 'rightLeg', sortable: false, align: 'left' },
        { text: 'Logged', value: 'created_at', sortable: false, align: 'left' }
      ],
      rows: [
        4,
        8,
        12,
        {
          'text': '$vuetify.dataIterator.rowsPerPageAll',
          'value': -1
        }
      ]
    }
  },
  props: ['user', 'report'],
  watch: {
    queryDateStart (newValue) {
      if (newValue) {
        this.getUserStats()
      }
    }
  },
  created () {
    if (this.$route.name === 'Report Show') {
      this.dailyStats = this.report.daily_stats
      this.measurements = this.measurements
      this.weeklyStats = this.report.weekly_stats
      this.queryDateStart = moment.unix(this.report.start_date)
      this.queryDateEnd = moment.unix(this.report.end_date)
    } else {
      this.getUserMeasurements()
    }
  },
  methods: {
    getUserMeasurements: function () {
      var self = this
      if (!self.fetched) {
        db.collection('user_measurements').where('user_id', '==', self.$route.params.userId).orderBy('milestone').get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var measurement = doc.data()
            self.$set(measurement, 'id', doc.id)
            self.measurements.push(measurement)
          })
          self.fetched = true
          self.getUserStats()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    getUserStats: function (updating) {
      this.loading = true
      var self = this
      db.collection('user_daily_stats').where('user_id', '==', self.$route.params.userId)
        .where('user_id', '==', self.$route.params.userId)
        .orderBy('created_at')
        .startAt(moment(this.queryDateStart).unix())
        .limit(7)
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            self.pushStat(doc.data())
          })
          if (updating) {
            self.snack.text = 'Weight unit: ' + self.units.weight
            self.snack.active = true
          }
          self.getUserReports()
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
    },
    updateUserStats: function (updating) {
      this.loading = true
      var self = this
      db.collection('user_daily_stats').where('user_id', '==', self.$route.params.userId)
        .where('user_id', '==', self.$route.params.userId)
        .orderBy('created_at')
        .startAt(moment(this.queryDateStart).unix())
        .limit(7)
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            self.pushStat(doc.data())
          })
          self.loading = false
        }).catch(err => {
          console.log(err)
          self.loading = false
        })
    },
    getUserReports: function () {
      var self = this
      db.collection('user_reports').where('user_id', '==', self.$route.params.userId).orderBy('created_at').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = doc.data()
          self.$set(data, 'id', doc.id)
          self.reports.push(data)
        })
        self.loading = false
      }).catch(err => {
        console.log(err)
        self.loading = false
      })
    },
    pushStat (stat) {
      var newStat = stat
      if (typeof newStat.calories === 'undefined') {
        newStat.calories = 0
      }
      if (typeof newStat.protein === 'undefined') {
        newStat.protein = 0
      }
      if (typeof newStat.weight === 'undefined') {
        newStat.weight = 0
      }
      if (typeof newStat.steps === 'undefined') {
        newStat.steps = 0
      }
      newStat.day = moment.unix(newStat.created_at).dayOfYear()
      this.dailyStats.push(newStat)
    },

    validateDates () {
      if (this.form.startDate && this.form.endDate) {
        if (this.form.weekly) {
          var startPlusOne = moment(this.form.startDate).subtract(1, 'days')
          var differenceWeekly = moment(this.form.endDate).diff(startPlusOne, 'days')
          if (differenceWeekly % 7 === 0) {
            return true
          } else {
            this.loading = false
            this.alert.active = true
            return false
          }
        } else {
          var difference = moment(this.form.endDate).diff(this.form.startDate, 'days')
          if (difference === 6) {
            this.alert.active = false
            return true
          } else {
            this.loading = false
            this.alert.active = true
            return false
          }
        }
      } else {
        this.loading = false
        this.alert.active = true
        return false
      }
    },
    applyDateRange () {
      this.loading = true
      if (this.validateDates()) {
        this.queryDateStart = moment(this.form.startDate).startOf('day')
        this.queryDateEnd = moment(this.form.endDate).endOf('day')
        this.weeklyStats = this.form.weekly
        this.pickerDialog = false
        this.loading = false
        this.form.startDate = null
        this.form.endDate = null
      }
    },
    chunkArray (myArray, chunkSize, average = false) {
      var index = 0
      var arrayLength = myArray.length
      var tempArray = []
      for (index = 0; index < arrayLength; index += chunkSize) {
        var myChunk = myArray.slice(index, index + chunkSize)
        if (average) {
          var filteredChunk = myChunk.filter(value => value !== 0)
          filteredChunk.sort()
          if (filteredChunk.length % 2) {
            var medianArry = []
            var index1 = filteredChunk[Math.round((filteredChunk.length) / 2)]
            var index2 = filteredChunk[(Math.round((filteredChunk.length) / 2)) - 1]
            medianArry.push(index1)
            medianArry.push(index2)
            const reducer = (accumulator, currentValue) => accumulator + currentValue
            var multiMedian = medianArry.reduce(reducer) / 2
            tempArray.push(multiMedian)
          } else {
            var singleMedian = filteredChunk[Math.round((filteredChunk.length - 1) / 2)]
            tempArray.push(singleMedian)
          }
        } else {
          const reducer = (accumulator, currentValue) => accumulator + currentValue
          var sumChunk = myChunk.reduce(reducer)
          tempArray.push(sumChunk)
          sumChunk = null
        }
      }
      return tempArray
    },
    addReport (data) {
      this.reports.push(data)
    },
    updateReport (item) {
      var self = this
      var reportRef = db.collection('user_reports').doc(item.id)
      reportRef.set({
        message: item.message
      }, { merge: true })
        .then(function () {
          self.snack.active = true
        })
        .catch(function (error) {
          if (error) {
            console.error('Error', error)
          }
        })
    },
    deleteReport (item) {
      var self = this
      self.loadingDelete = true
      db.collection('user_reports').doc(item.id).delete().then(function () {
        const index = self.reports.indexOf(item)
        self.reports.splice(index, 1)
        self.loadingDelete = false
        self.deleteNotification(item)
      }).catch(function (error) {
        console.error('Error removing document: ', error)
      })
    },
    deleteNotification (item) {
      var notificationsRef = db.collection('notifications')
      notificationsRef.where('report_id', '==', item.id).limit(1).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const id = doc.id
          db.collection('notifications').doc(id).delete()
        })
      }).catch(function (error) {
        console.error('Error removing document: ', error)
      })
    }
  },
  computed: {
    activeLabels: function () {
      if (!this.weeklyStats) {
        var startMinusOne = moment(this.queryDateStart).subtract(1, 'days')
        var days = []
        for (let index = 0; index < 7; index++) {
          startMinusOne = moment(startMinusOne).add(1, 'days')
          days.push(moment(startMinusOne).format('ddd'))
        }
        return days
      } else if (this.weeklyStats) {
        var difference = (moment(this.queryDateEnd).diff(this.queryDateStart, 'days') + 1) / 7
        var weeks = []
        var num = 0
        for (let index = 0; index < difference; index++) {
          num++
          weeks.push(num.toString())
        }
        return weeks
      }
    },
    activeDaysOfYear: function () {
      var startMinusOne = moment(this.queryDateStart).subtract(1, 'days')
      var queryDaysCount = (moment(this.queryDateEnd).diff(this.queryDateStart, 'days') + 1)
      var days = []
      for (let index = 0; index < queryDaysCount; index++) {
        startMinusOne = moment(startMinusOne).add(1, 'days')
        days.push(moment(startMinusOne).dayOfYear())
      }
      return days
    },
    activeStats: function () {
      var self = this
      var filteredStats = []
      function addToFiltered (arr, day) {
        const found = arr.some(el => el.day === day)
        if (!found) {
          var date = moment().dayOfYear(day)
          filteredStats.push({ calories: 0, protein: 0, steps: 0, weight: 0, day: day, created_at: moment(date).unix() })
        } else {
          var stat = arr.filter(function (stat) {
            return stat.day === day
          })
          filteredStats.push(stat[0])
        }
      }
      self.activeDaysOfYear.forEach(element => {
        addToFiltered(self.dailyStats, element)
      })
      if (filteredStats.length > 0) {
        return filteredStats
      } else {
        return null
      }
    },
    activeCalories: function () {
      var self = this
      if (self.activeStats) {
        var mapped = _.map(self.activeStats, _.partialRight(_.pick, ['day', 'calories', 'protein']))
        var newArray = mapped.filter(value => Object.keys(value).length !== 0)
        self.activeDaysOfYear.forEach(day => {
          if (!newArray.some(el => el.day === day)) {
            var newDefault = {}
            newDefault.calories = 0
            newDefault.day = day
            newArray.push(newDefault)
          }
        })
        var values = []
        newArray.forEach(e => {
          values.push([e.calories, e.protein])
        })
        if (this.weeklyStats) {
          // Split in group of 7 items
          var weeklyStats = this.chunkArray(values, 7)
          return weeklyStats
        } else {
          return values
        }
      } else {
        return [0, 0, 0, 0, 0, 0, 0]
      }
    },
    activeCaloriesOnly: function () {
      const mappedCalories = this.activeCalories.map(function (cal) {
        return cal[0]
      })
      return mappedCalories
    },
    activeWeight: function () {
      var self = this
      if (self.activeStats) {
        var mapped = _.map(self.activeStats, _.partialRight(_.pick, ['day', 'weight']))
        var newArray = mapped.filter(value => Object.keys(value).length !== 0)
        self.activeDaysOfYear.forEach(day => {
          if (!newArray.some(el => el.day === day)) {
            var newDefault = {}
            newDefault.weight = 0
            newDefault.day = day
            newArray.push(newDefault)
          }
        })
        var values = []
        newArray.forEach(e => {
          values.push(e.weight)
        })
        if (this.weeklyStats) {
          // Split in group of 3 items
          var weeklyStats = this.chunkArray(values, 7, true)
          return weeklyStats
        } else {
          return values
        }
      } else {
        return [0, 0, 0, 0, 0, 0, 0]
      }
    },
    activeSteps: function () {
      var self = this
      if (self.activeStats) {
        var mapped = _.map(self.activeStats, _.partialRight(_.pick, ['day', 'steps']))
        var newArray = mapped.filter(value => Object.keys(value).length !== 0)
        self.activeDaysOfYear.forEach(day => {
          if (!newArray.some(el => el.day === day)) {
            var newDefault = {}
            newDefault.steps = 0
            newDefault.day = day
            newArray.push(newDefault)
          }
        })
        var values = []
        newArray.forEach(e => {
          values.push(e.steps)
        })
        if (this.weeklyStats) {
          // Split in group of 3 items
          var weeklyStats = this.chunkArray(values, 7)
          return weeklyStats
        } else {
          return values
        }
      } else {
        return [0, 0, 0, 0, 0, 0, 0]
      }
    },
    activeCaloriesTotals: function () {
      if (this.activeCalories) {
        const mappedCalories = this.activeCalories.map(function (cal) {
          return cal[0]
        })
        var obj = {}
        const reducer = (accumulator, currentValue) => accumulator + currentValue
        const average = mappedCalories.reduce(reducer) / mappedCalories.length
        this.$set(obj, 'total', mappedCalories.reduce(reducer))
        this.$set(obj, 'average', average)
        return obj
      } else {
        return null
      }
    },
    activeWeightTotals: function () {
      if (this.activeWeight) {
        var minusEmpty = this.activeWeight.filter(value => value !== 0)
        if (minusEmpty.length > 0) {
          var result = {}
          var first = minusEmpty[0]
          var last = minusEmpty[minusEmpty.length - 1]
          result.value = Math.abs(first - last)
          if (first > last) {
            result.color = 'secondary'
            result.icon = 'keyboard_arrow_down'
          } else if (first < last) {
            result.color = 'red'
            result.icon = 'keyboard_arrow_up'
          } else if (first === last) {
            result.color = 'warning'
            result.icon = ''
          } else {
            result.color = 'white'
            result.icon = ''
          }
          return result
        } else {
          return null
        }
      } else {
        return null
      }
    },
    weightMessage () {
      if (this.weeklyStats) {
        return 'since week 1 average.'
      } else {
        return 'since the week start.'
      }
    },
    activeStepsTotals: function () {
      if (this.activeSteps) {
        var obj = {}
        const reducer = (accumulator, currentValue) => accumulator + currentValue
        const average = this.activeSteps.reduce(reducer) / this.activeSteps.length
        this.$set(obj, 'total', this.activeSteps.reduce(reducer))
        this.$set(obj, 'average', average)
        return obj
      } else {
        return null
      }
    },
    startMin () {
      if (this.form.endDate && !this.form.weekly) {
        return moment(this.form.endDate).subtract(6, 'days').format('YYYY-MM-DD')
      } else if (this.form.endDate && this.form.weekly) {
        return moment(this.form.endDate).subtract(55, 'days').format('YYYY-MM-DD')
      } else {
        return '2019-01-01'
      }
    },
    startMax () {
      if (this.form.endDate && !this.form.weekly) {
        return moment(this.form.endDate).subtract(6, 'days').format('YYYY-MM-DD')
      } else if (this.form.endDate && this.form.weekly) {
        return moment(this.form.endDate).format('YYYY-MM-DD')
      } else {
        return moment().subtract(6, 'days').format('YYYY-MM-DD')
      }
    },
    endMin () {
      if (this.form.startDate && !this.form.weekly) {
        return moment(this.form.startDate).add(6, 'days').format('YYYY-MM-DD')
      } else if (this.form.startDate && this.form.weekly) {
        return moment(this.form.startDate).add(6, 'days').format('YYYY-MM-DD')
      } else {
        return '2019-01-01'
      }
    },
    endMax () {
      if (this.form.startDate && !this.form.weekly) {
        return moment(this.form.startDate).add(6, 'days').format('YYYY-MM-DD')
      } else if (this.form.startDate && this.form.weekly) {
        var today = moment.utc().endOf('day')
        var plus12Weeks = moment.utc(this.form.startDate).add(84, 'days').startOf('day')
        if (moment(plus12Weeks).isAfter(today)) {
          return moment().format('YYYY-MM-DD')
        } else {
          return moment(this.form.startDate).add(84, 'days').format('YYYY-MM-DD')
        }
      } else {
        return moment().format('YYYY-MM-DD')
      }
    },
    allowDatesEnd () {
      if (this.form.startDate && this.form.weekly) {
        return null
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
  .hidden {
    display: none;
  }
  .v-sheet--offset.mx-auto.v-sheet {
    top: -16px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/statistics.vue